import { render } from "./header.vue?vue&type=template&id=f1d8d64c&scoped=true"
import script from "./header.vue?vue&type=script&lang=js"
export * from "./header.vue?vue&type=script&lang=js"

import "./header.vue?vue&type=style&index=0&id=f1d8d64c&scoped=true&lang=scss"
import "./header.vue?vue&type=style&index=1&id=f1d8d64c&lang=scss"

import exportComponent from "C:\\Project\\DeepLink\\OrionRaceWeb\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f1d8d64c"]])

export default __exports__